import React from 'react';
import { useQuery } from 'react-query';
import { loanService } from '../../services/loanService';
import { formatCurrency } from '../../utils/formatters';

const LoanProducts = () => {
  const { data, isLoading } = useQuery('loan-products', () => loanService.getLoanProducts());

  if (isLoading) return <div>Loading loan products...</div>;

  const products = data?.data || [];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Loan Products</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <div key={product.id} className="bg-white rounded-lg shadow p-6">
            <h3 className="text-xl font-semibold mb-2">{product.product_name}</h3>
            <p className="text-gray-600 text-sm mb-4">{product.loan_type}</p>

            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Amount Range:</span>
                <span className="font-medium">
                  {formatCurrency(product.min_amount)} - {formatCurrency(product.max_amount)}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Interest Rate:</span>
                <span className="font-medium">{product.default_interest_rate}% ({product.interest_type})</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Duration:</span>
                <span className="font-medium">{product.min_duration_months} - {product.max_duration_months} months</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Processing Fee:</span>
                <span className="font-medium">{formatCurrency(product.processing_fee)}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Late Fee:</span>
                <span className="font-medium">{product.late_fee_percentage}%</span>
              </div>
            </div>

            <button className="mt-4 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
              Apply for this Loan
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoanProducts;